import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionKitchenEquippedPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionKitchenEquipped.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionKitchenEquipped.button1'),
          value: 'basic_setup',
        },
        {
          text: t('pages.onboarding.questionKitchenEquipped.button2'),
          value: 'moderate_setup',
        },
        {
          text: t('pages.onboarding.questionKitchenEquipped.button3'),
          value: 'well_equipped',
        },
        {
          text: t('pages.onboarding.questionKitchenEquipped.button4'),
          value: 'professional_level',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
